export class KlaviyoError extends Error {
  constructor(public readonly response: Response) {
    super(`Klaviyo API responded: ${response.statusText}`);
  }
}
